import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AssetTypeList from './AssetTypeList';
import AssetTypeForm from './AssetTypeForm';

const AssetTypeRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AssetTypeList />} />
      <Route path="/new" element={<AssetTypeForm />} />
      <Route path="/edit/:id" element={<AssetTypeForm />} />
    </Routes>
  );
};

export default AssetTypeRoutes; 